/* eslint-disable @typescript-eslint/no-this-alias */
import React from 'react';
import { createRoot } from 'react-dom/client'
import BillingAddressCard from './BillingAddressCard'

const BillingAddressCardRoot = (props) => {
	return <BillingAddressCard {...props} />
}

export default BillingAddressCardRoot;

if(typeof window.BillingAddressCardRoots == 'undefined') {
    window.BillingAddressCardRoots = {};
}

// MOUNT/UNMOUNT OK
window.BillingAddressCardRoot = function (sectionTag = 'global') {
	let allElts = document.querySelectorAll('[data-react="billing-address-card"]');
	for (const element of allElts) {
		const uniqueId = element.dataset.windowId || sectionTag;
        
        if (window.BillingAddressCardRoots[uniqueId] && window.BillingAddressCardRoots[uniqueId].unmount) {
            window.BillingAddressCardRoots[uniqueId].unmount();
        }

		let attr = { ...BillingAddressCardRoot.defaultProps };

		attr.windowId = uniqueId;
        attr.connected_as = '';

		if (element.dataset.context && element.dataset.context != '') {
            attr.context = element.dataset.context;
        }
        else {
            attr.context = '';
        }
        if ( element.dataset.id && element.dataset.id != '' ) {
            attr.id = element.dataset.id;
        }
        else {
            attr.id = '';
        }
        if ( element.dataset.cardTitle && element.dataset.cardTitle != '' ) {
            attr.cardTitle = element.dataset.cardTitle;
        }
        else {
            attr.cardTitle = '';
        }
        if ( element.dataset.businessName && element.dataset.businessName != '' ) {
            attr.businessName = element.dataset.businessName;
        }
        else {
            attr.businessName = '';
        }
        if ( element.dataset.lastName && element.dataset.lastName != '' ) {
            attr.lastName = element.dataset.lastName;
        }
        else {
            attr.lastName = '';
        }
        if ( element.dataset.firstName && element.dataset.firstName != '' ) {
            attr.firstName = element.dataset.firstName;
        }
        else {
            attr.firstName = '';
        }
        if ( element.dataset.isDefault && element.dataset.isDefault != '' ) {
            attr.isDefault = element.dataset.isDefault;
        }
        else {
            attr.isDefault = '';
        }
        if ( element.dataset.address && element.dataset.address != '' ) {
            attr.address = element.dataset.address;
        }
        else {
            attr.address = '';
        }
        if ( element.dataset.postalCode && element.dataset.postalCode != '' ) {
            attr.postalCode = element.dataset.postalCode;
        }
        else {
            attr.postalCode = '';
        }
        if ( element.dataset.city && element.dataset.city != '' ) {
            attr.city = element.dataset.city;
        }
        else {
            attr.city = '';
        }
        if ( element.dataset.country && element.dataset.country != '' ) {
            attr.country = element.dataset.country;
        }
        else {
            attr.country = '';
        }
        if ( element.dataset.taxId && element.dataset.taxId != '' ) {
            attr.taxId = element.dataset.taxId;
        }
        else {
            attr.taxId = '';
        }
        if ( element.dataset.col && element.dataset.col != '' ) {
            attr.col = element.dataset.col;
        }
        else {
            attr.col = '';
        }
        if ( element.dataset.onDefineAsDefault && element.dataset.onDefineAsDefault != '' ) {
            attr.onDefineAsDefault = element.dataset.onDefineAsDefault;
        }
        else {
            attr.onDefineAsDefault = '';
        }
        if ( element.dataset.onDelete && element.dataset.onDelete != '' ) {
            attr.onDelete = element.dataset.onDelete;
        }
        else {
            attr.onDelete = '';
        }
        if ( element.dataset.membres_id && element.dataset.membres_id != '' ) {
            attr.membres_id = element.dataset.membres_id;
        }
        else {
            attr.membres_id = '';
        }

		const root = createRoot(element);
        root.render(<BillingAddressCardRoot {...attr} />);
        
        window.BillingAddressCardRoots[uniqueId] = root;
	}
}
